export default __webpack_public_path__ + "static/media/Vazir-Bold.ded93117.eot";